import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import _, { forEach, set } from 'lodash';
import tokenService from "../../../Common/tokenDecoder";
import xlsx from 'json-as-xlsx';
import CreateIcon from '@material-ui/icons/Create';
import { IconButton } from '@material-ui/core';
import MaterialTable from "material-table";

export const RouteListing = ({ routeData, handleClick, editEnabled, groups, operationEntity, collectionCategory, routes }) => {

    const [route, setRoute] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const contentRowNames = ["collectionPointCode", "collectionPointName", "isActive"];
    const csvHeaders = [
        { label: "CollectionPoint Code", value: "collectionPointCode" },
        { label: "CollectionPoint Name", value: "collectionPointName" },
        { label: "Is Active", value: "isActive" }
    ];

    useEffect(() => {
        trackPromise(
            setRouteData()
        )
    }, [routeData]);

    async function setRouteData() {
        destroyDataTable();
        await setRoute(routeData);

        const comlpeteData = [...routeData];
        const result = [...comlpeteData]
        result.forEach(x => {
            x.isActive = (x.isActive == true ? "Active" : "InActive");
        });
        setCsvData(result)

        createDataTable();
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ?
                (da[row] === true ? <td key={index}>Inactive</td> : <td key={index}>Active</td>)
                : <td key={index}>{da[row] + " "}</td>
            )
        )
    });

    function createFile() {
        var settings = {
            sheetName: 'Routes',
            fileName: 'Routes',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            collectionPointCode: "Group :" + groups[routes.groupID],
            collectionPointName: "Operation Entity : " + operationEntity[routes.operationEntityID],
            isActive: "Collection Category: " + (collectionCategory[routes.collectionCatagoryID] === undefined ? "All Collection Category" : collectionCategory[routes.collectionCatagoryID])
        }
        var newRow2 = {
            collectionPointCode: "Generated date/time : " + new Date().toLocaleString(),
            collectionPointName: "Generated user : " + tokenService.getUserNameFromToken()
        }
        copyOfCsv.push({}, {}, newRow1)
        copyOfCsv.push(newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="table-responsive row-top-gap">
                            {route.length > 0 ?
                                <MaterialTable
                                    title="Multiple Actions Preview"
                                    columns={[
                                        { title: 'Route Code', field: 'collectionPointCode', headerStyle: { fontWeight: "bold" } },
                                        { title: 'Route Name', field: 'collectionPointName', headerStyle: { fontWeight: "bold" } },
                                        {
                                            title: 'Status', field: 'isActive',
                                            render: rowData => rowData.isActive == true ? "Active" : "Inactive", headerStyle: { fontWeight: "bold" }
                                        },
                                        {
                                            title: 'Action', field: 'select', headerStyle: { fontWeight: "bold", textAlign: "center" },
                                            render: (data) => (
                                                <center>
                                                    <IconButton aria-label="create" onClick={() => handleClick(data)}>
                                                        <CreateIcon />
                                                    </IconButton>
                                                </center>
                                            )
                                        }
                                    ]}
                                    data={route}
                                    options={{
                                        exportButton: false,
                                        showTitle: false,
                                        headerStyle: { textAlign: "left", height: '1%' },
                                        cellStyle: { textAlign: "left" },
                                        columnResizable: false,
                                        actionsColumnIndex: -1
                                    }}
                                />
                                : null}
                            <div className="pt-2">
                                <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="Excel"
                                    onClick={createFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}